import useTranslator from "../../hooks/useTranslator";
import { Icon } from "../design";
import "./DocsStatus.css";

const DocsStatus = ({ missingCount, isPending = false }) => {
  const { _t } = useTranslator();

  if (isPending) return "-";

  return missingCount === 0 ? (
    <span className="docs-status docs-status--complete">
      <Icon name="checkCircle" size={18} />
      {_t("complete")}
    </span>
  ) : (
    <span className="docs-status docs-status--missing">
      <Icon name="warning" size={18} />
      {missingCount} {_t("docsMissing")}
    </span>
  );
};

export default DocsStatus;
